export var ActionKeys;
(function (ActionKeys) {
    ActionKeys["START"] = "START";
    ActionKeys["FINISH"] = "FINISH";
    ActionKeys["ERROR"] = "ERROR";
    ActionKeys["UPDATE"] = "UPDATE";
})(ActionKeys || (ActionKeys = {}));
export var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["CORRECT"] = "CORRECT";
    Status["INCORRECT"] = "INCORRECT";
})(Status || (Status = {}));
export const actions = {
    start: (content) => ({
        type: ActionKeys.START,
        payload: content
    }),
    finish: (content) => ({
        type: ActionKeys.FINISH,
        payload: content
    }),
    error: (content) => ({
        type: ActionKeys.ERROR,
        payload: content
    })
};
export const initialValues = [];
const getPendingValues = state => state;
export function createPendingValue() {
    const reducer = (state = initialValues, action) => {
        switch (action.type) {
            case ActionKeys.START: {
                const newValue = Object.assign(Object.assign({}, action.payload), { status: Status.PENDING });
                const newState = [...state, newValue];
                return newState;
            }
            case ActionKeys.FINISH: {
                const newState = state.map((item, index) => index === action.payload.index
                    ? Object.assign(Object.assign({}, item), { status: Status.CORRECT }) : item);
                return newState;
            }
            case ActionKeys.ERROR: {
                const newState = state.map((item, index) => index === action.payload.index
                    ? Object.assign(Object.assign({}, item), { status: Status.INCORRECT }) : item);
                return newState;
            }
            default:
                return state;
        }
    };
    return {
        actions,
        reducer,
        middleware: [],
        selectors: { getPendingValues }
    };
}
//# sourceMappingURL=PendingValues.js.map